import { parseBankAccounts } from "@/services/rest/bank-info";
import { createAction, createSlice } from "@reduxjs/toolkit";

export const techexcelSlice = createSlice({
    name:"techExcel",
    initialState:{
        isLoading: true,
        hasError: null,
        bankAccounts:[],
        nominees: null
    },

    reducers:{
        setLoading: (state,action) => {
            state.isLoading = action.payload;
            if(action.payload){
                state.bankAccounts = []
                state.hasError = null
            }
        },
        setTechExcelData: (state, action) => {
            state.isLoading = false,
            state.bankAccounts = action.payload.accounts
            state.nominees = action.payload.nomineeDetails
            state.hasError = null;
        },
        setError: (state,action) => {
            state.isLoading = false,
            state.hasError = action.payload
        }
    }
})

export const setLoadingAction = createAction("techExcel/setLoading")
export const setTechExcelDataAction = createAction("techExcel/setTechExcelData")
export const setErrorAction = createAction("techExcel/setError");

export default techexcelSlice.reducer;